// garuda - Reading Mode Toggle Component

import { useEffect, useState } from "react";
import { SpectaclesIcon } from "./Icons";
import "./ReadingModeToggle.css";

const ReadingModeToggle = ({ isReadingMode, onToggle }) => {
  const [showPulse, setShowPulse] = useState(() => {
    // Check if pulse has been shown in this session
    return !sessionStorage.getItem("readingModePulseShown");
  });

  useEffect(() => {
    // Only run if pulse should be shown
    if (showPulse) {
      // Mark as shown in session storage
      sessionStorage.setItem("readingModePulseShown", "true");

      // Show pulsating animation for first 3 seconds
      const timer = setTimeout(() => {
        setShowPulse(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showPulse]);

  return (
    <button
      className={`reading-mode-toggle ${showPulse ? "pulse" : ""} ${isReadingMode ? "active" : ""}`}
      onClick={onToggle}
      title={isReadingMode ? "Exit Reading Mode" : "Enter Reading Mode"}
      aria-label="Toggle Reading Mode"
    >
      <SpectaclesIcon />
    </button>
  );
};

export default ReadingModeToggle;
